import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=3627805d&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=3627805d&prod&scoped=true&lang=css"
import style1 from "./OrderList.vue?vue&type=style&index=1&id=3627805d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3627805d",
  null
  
)

export default component.exports